module.exports = __webpack_public_path__ + "static/media/trackorder-preparing-order.2c37b7a9.png";